import React, { useEffect, useState } from 'react';
import Sidebar from '../components/ui/Sidebar';
import RoleView from '../components/ui/RoleView';
import API_URL from '../config';
import useScreenWidth from '../hooks/useScreenWidth';
import { FaBoxOpen, FaUser } from 'react-icons/fa';


const Insumos = () => {
  // ---------- ESTADOS ----------
  const [lista, setLista] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [sucursales, setSucursales] = useState([]);

  // Modal AÑADIR
  const [modalAgregarUnidades, setModalAgregarUnidades] = useState(false);
  const [productoSel, setProductoSel] = useState(null);
  const [cantidadAdd, setCantidadAdd] = useState(1);

  // Modal RESTAR
  const [modalRestar, setModalRestar] = useState(false);
  const [productoResta, setProductoResta] = useState(null);
  const [cantidadResta, setCantidadResta] = useState(1);
  const [sucursalId, setSucursalId] = useState('');

  // Modal SOLICITAR
  const [modalSolicitar, setModalSolicitar] = useState(false);
  const [productoSolicita, setProductoSolicita] = useState(null);

  // Modal para AGREGAR NUEVO INSUMO
  const [modalNuevoInsumo, setModalNuevoInsumo] = useState(false);
  const [nuevoNombre, setNuevoNombre] = useState('');
  const [nuevoMarca, setNuevoMarca] = useState('');
  const [nuevoPresentacion, setNuevoPresentacion] = useState('');
  const [nuevoFecha, setNuevoFecha] = useState('');
  const [nuevoUnidades, setNuevoUnidades] = useState(1);
  const [requiereVencimiento, setRequiereVencimiento] = useState(true);
  const [nuevoLote, setNuevoLote] = useState('');

  // Modal para EDITAR
  const [modalEditarInsumo, setModalEditarInsumo] = useState(false);
  const [insumoSeleccionado, setInsumoSeleccionado] = useState(null);
  const [editarMarca, setEditarMarca] = useState('');
  const [editarPresentacion, setEditarPresentacion] = useState('');
  const [editarFecha, setEditarFecha] = useState('');
  const [editarLote, setEditarLote] = useState('');

  // Modal para ELIMINAR
  const [modalEliminarInsumo, setModalEliminarInsumo] = useState(false);
  const [insumoAEliminar, setInsumoAEliminar] = useState(null);

  const abrirModalEliminar = (insumo) => {
    setInsumoAEliminar(insumo);
    setModalEliminarInsumo(true);
  };

  // Recorrer contenido si el sidebar de oculta
  const screenWidth = useScreenWidth();
  const [sidebarVisible, setSidebarVisible] = useState(screenWidth >= 768);

  // Estilo para las columnas de la tabla
  const styles = {
    tableHeader: {
      backgroundColor: '#a3bac0',
      color: '#333',
      fontWeight: 'bold',
      padding: '15px',
    },
    tableRow: {
      backgroundColor: '#daeeeeff',
      color: '#333',
      padding: '12px',
    },
    tableRowAlt: {
      backgroundColor: '#f0fbfbff',
      color: '#333',
      padding: '12px',
    },
  };

  // Estilo para los botones
  const iconButtonStyle = {
    width: '70px',
    cursor: 'pointer',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    transform: 'scale(1)',
    boxShadow: 'none',
  };

  const iconButtonHover = {
    transform: 'scale(1.05)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
  };

  const iconButtonClick = {
    transform: 'scale(0.95)',
  };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = iconButtonHover.transform;
    e.currentTarget.style.boxShadow = iconButtonHover.boxShadow;
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = iconButtonStyle.transform;
    e.currentTarget.style.boxShadow = iconButtonStyle.boxShadow;
  };

  const handleMouseDown = (e) => {
    e.currentTarget.style.transform = iconButtonClick.transform;
  };

  const handleMouseUp = (e) => {
    e.currentTarget.style.transform = iconButtonHover.transform;
  };

  const inputStyle = {
    width: '100%',
    padding: '0.6rem',
    fontSize: '1rem',
    borderRadius: '8px',
    border: '1px solid #ccc',
    marginBottom: '1rem'
  };

  // ---------- CARGA INICIAL ----------
  useEffect(() => {
    fetch(`${API_URL}/api/insumos`)
      .then(r => r.json())
      .then(setLista)
      .catch(console.error);

    fetch(`${API_URL}/api/sucursales`)
      .then(r => r.json())
      .then(setSucursales)
      .catch(console.error);
  }, []);

  // ---------- FUNCIONES AUXILIARES ----------
  const listaFiltrada = lista
    .filter(r => r.activo !== 0)
    .filter(r => r.nombre.toLowerCase().includes(filtro.toLowerCase()));

  // ---------- MODAL AGREGAR POR UNIDADES ----------
  const abrirModalAgregarUnidades = (prod) => {
    setProductoSel(prod);
    setCantidadAdd(1);
    setModalAgregarUnidades(true);
  };

  const confirmarAgregar = async () => {
    if (!cantidadAdd || cantidadAdd <= 0) return alert('Cantidad inválida');
    const nuevas = productoSel.unidades + Number(cantidadAdd);
    try {
      await fetch(`${API_URL}/api/insumos/${productoSel.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...productoSel, unidades: nuevas }),
      });
      setLista(prev => prev.map(r => (r.id === productoSel.id ? { ...r, unidades: nuevas } : r)));
      setModalAgregarUnidades(false);
      alert(`Se añadieron ${cantidadAdd} unidades de ${productoSel.nombre} correctamente`);
    } catch (e) {
      alert('Error al agregar');
    }
  };

  // ---------- MODAL RESTAR ----------
  const abrirModalRestar = (prod) => {
    setProductoResta(prod);
    setCantidadResta(1);
    setSucursalId('');
    setModalRestar(true);
  };

  const confirmarResta = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user?.id) return alert('Usuario no identificado. Inicia sesión nuevamente.');
    if (!cantidadResta || cantidadResta <= 0) return alert('Cantidad inválida');
    if (!sucursalId) return alert('Selecciona una sucursal');
    const nuevas = productoResta.unidades - Number(cantidadResta);
    if (nuevas < 0) return alert('No hay suficientes unidades');
    const sucursalIdNum = Number(sucursalId);
    const nomSuc = sucursales.find(s => s.id === sucursalIdNum)?.nombre || '';
    try {
      await fetch(`${API_URL}/api/insumos/${productoResta.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...productoResta, unidades: nuevas }),
      });
      await fetch(`${API_URL}/api/movimientos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo_producto: 'insumo',
          producto_id: productoResta.id,
          sucursal_id: sucursalIdNum,
          cantidad: Number(cantidadResta),
          usuario_id: user.id
        }),
      });
      setLista(prev => prev.map(r => (r.id === productoResta.id ? { ...r, unidades: nuevas } : r)));
      alert(`Se descontaron ${cantidadResta} unidades de ${productoResta.nombre} → Sucursal: ${nomSuc}`);
      setModalRestar(false);
    } catch (e) {
      alert('Error al restar');
    }
  };

  // ---------- MODAL SOLICITAR ----------
  const abrirModalSolicitar = (prod) => {
    setProductoSolicita(prod);
    setModalSolicitar(true);
  };

  const confirmarSolicitud = async () => {
    try {
      await fetch(`${API_URL}/api/insumos/mail`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre: productoSolicita.nombre,
          unidades: productoSolicita.unidades,
          destinatario: process.env.MAIL_TO,
          mensaje: 'Verifica que el producto realmente necesita ser repuesto.',
        }),
      });
      alert('Solicitud enviada con éxito');
      setModalSolicitar(false);
    } catch (e) {
      alert('Error al enviar solicitud');
    }
  };

  // ---------- AÑADIR NUEVO PRODUCTO ----------
  const confirmarNuevo = async () => {
    if (
      !nuevoNombre.trim() ||
      !nuevoMarca.trim() ||
      !nuevoPresentacion.trim() ||
      (requiereVencimiento && !nuevoFecha) ||
      !nuevoUnidades ||
      !nuevoLote.trim()
    ) {
      return alert('Completa todos los campos');
    }
    try {
      await fetch(`${API_URL}/api/insumos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre: nuevoNombre.trim(),
          marca: nuevoMarca.trim(),
          presentacion: nuevoPresentacion.trim(),
          fecha_vencimiento: requiereVencimiento ? nuevoFecha : null,
          unidades: Number(nuevoUnidades),
          requiere_vencimiento: requiereVencimiento,
          lote: nuevoLote.trim()
        }),
      });
      setNuevoNombre('');
      setNuevoMarca('');
      setNuevoPresentacion('');
      setNuevoFecha('');
      setNuevoUnidades(1);
      setModalNuevoInsumo(false);
      setNuevoLote('');
      const data = await fetch(`${API_URL}/api/insumos`).then(r => r.json());
      setLista(data);
      alert(`Se ha registrado exitosamente el insumo ${nuevoNombre}`);
    } catch (e) {
      alert('Error al agregar');
    }
  };

  // ---------- EDITAR PRODUCTO ----------
  const abrirModalEditar = (insumo) => {
    setInsumoSeleccionado(insumo);
    setEditarMarca(insumo.marca);
    setEditarPresentacion(insumo.presentacion);
    setEditarFecha(insumo.fecha_vencimiento?.split('T')[0] || '');
    setEditarLote(insumo.lote || '');
    setModalEditarInsumo(true);
  };

  const confirmarEdicion = async () => {
    try {
      const res = await fetch(`${API_URL}/api/insumos/${insumoSeleccionado.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre: insumoSeleccionado.nombre,
          marca: editarMarca,
          presentacion: editarPresentacion,
          fecha_vencimiento: editarFecha,
          unidades: insumoSeleccionado.unidades,
          lote: editarLote,
        }),
      });
      if (res.ok) {
        alert(`El insumo "${insumoSeleccionado.nombre}" ha sido actualizado con éxito.`);
        setModalEditarInsumo(false);
        const data = await fetch(`${API_URL}/api/insumos`).then(r => r.json());
        setLista(data);
      } else {
        alert('Error al guardar los cambios');
      }
    } catch (err) {
      console.error('Error al editar:', err);
      alert('Ocurrió un error al intentar actualizar el insumo.');
    }
  };

  // MODAL ELIMINAR
  const confirmarEliminacion = async () => {
    try {
      const res = await fetch(`${API_URL}/api/insumos/${insumoAEliminar.id}`, {
        method: 'DELETE',
      });
      if (res.ok) {
        setModalEliminarInsumo(false);
        const data = await fetch(`${API_URL}/api/insumos`).then(r => r.json());
        setLista(data);
        alert(`Insumo "${insumoAEliminar.nombre}" eliminado correctamente`);
      } else {
        alert('Error al eliminar el insumo');
      }
    } catch (err) {
      console.error('Error al eliminar:', err);
      alert('Error al eliminar');
    }
  };

  // ---------- RENDER ----------
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible} />

      <main
        style={{
          flex: 1,
          minHeight: '100vh',
          overflowX: 'auto',
          overflowY: 'visible',
          marginLeft: sidebarVisible ? '180px' : '0',
          padding: '2rem',
          backgroundColor: '#edf0f0',
          position: 'relative',
        }}
      >
        {/* Usuario + icono (arriba a la derecha) */}
          <div
            style={{
              position: 'absolute',
              top: '1.2rem',
              right: '2rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontFamily: "'Poppins', sans-serif",
              fontSize: '0.95rem',
              color: '#333',
              zIndex: 1001,
            }}
          >
            <FaUser
              style={{
                fontSize: '2.2rem',
                color: '#333',
                verticalAlign: 'middle',
              }}
            />
            <span>
              {localStorage.getItem('user')
                ? JSON.parse(localStorage.getItem('user')).username
                : 'Usuario'}
            </span>
          </div>

        {/* Título centrado */}
        <h2 style={{ textAlign: 'center', margin: '2.2rem auto 1.5rem' }}>Insumos</h2>
        <p
          style={{
            fontSize: '0.9rem',
            color: '#666',
            marginBottom: '1rem',
            textAlign: 'center'
          }}
        >
          Desliza horizontalmente para ver toda la tabla en dispositivos móviles.
        </p>

        {/* Buscador largo y redondeado con efecto hover */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            background: '#fff',
            border: '1px solid #ddd',
            borderRadius: '30px',
            padding: '0.6rem 1.2rem',
            width: '90%',
            maxWidth: '800px',
            margin: '0 auto 2rem',
            boxShadow: '0 2px 6px rgba(0,0,0,.08)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.02)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,.08)';
          }}
        >
          <input
            type="text"
            placeholder="Buscar por nombre"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            style={{
              border: 'none',
              outline: 'none',
              flex: 1,
              fontSize: '1rem',
              fontFamily: "'Poppins', sans-serif",
            }}
          />
        </div>

        {/* Botón hamburguesa (visible para todos) */}
        {!sidebarVisible && (
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <button
              onClick={() => setSidebarVisible(true)}
              style={{
                background: '#1f3339',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '0.6rem 1.2rem',
                fontSize: '1rem',
                cursor: 'pointer',
                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                minWidth: '150px',
              }}
            >
              ☰ Menú
            </button>
          </div>
        )}

        {/* Tarjeta principal con estilo unificado */}
        <div
          style={{
            background: '#fff',
            borderRadius: '20px',
            boxShadow: '0 4px 12px rgba(0,0,0,.06)',
            padding: '1.5rem',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.01)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,.06)';
          }}
        >
          {/* Contenedor responsivo con tabla */}
          <div
            style={{
              overflowX: 'auto',
              width: '100%',
              borderRadius: '16px',
              boxShadow: '0 4px 12px rgba(0,0,0,.06)',
              background: '#fff',
              padding: '1.5rem',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.005)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,.06)';
            }}
          >
            {/* Tabla moderna */}
            <div style={{ overflowX: 'auto', width: '100%' }}>
              <table style={{ width: '100%', minWidth: '1000px', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f9f9f9', borderBottom: '2px solid #e0e0e0' }}>
                    <th style={styles.tableHeader}>Nombre</th>
                    <th style={styles.tableHeader}>Marca</th>
                    <th style={styles.tableHeader}>Presentación</th>
                    <th style={styles.tableHeader}>Fecha venc.</th>
                    <th style={styles.tableHeader}>Lote</th>
                    <th style={styles.tableHeader}>Estado</th>
                    <th style={styles.tableHeader}>Unidades en existencia</th>
                    <th style={styles.tableHeader}>Añadir Unidades</th>
                    <th style={styles.tableHeader}>Descontar</th>
                    <th style={styles.tableHeader}>Solicitar</th>
                    <th style={styles.tableHeader}>Editar</th>
                    <th style={styles.tableHeader}>Eliminar</th>
                  </tr>
                </thead>
                <tbody>
                  {listaFiltrada.map((r, index) => (
                    <tr
                      key={r.id}
                      style={{
                        borderBottom: '1px solid #eee',
                        ...(index % 2 === 0 ? styles.tableRow : styles.tableRowAlt),
                      }}
                    >
                      <td style={{ padding: '12px', textAlign: 'center' }}>{r.nombre}</td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>{r.marca}</td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>{r.presentacion}</td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>
                        {r.fecha_vencimiento?.split('T')[0]}
                      </td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>{r.lote || '—'}</td>
                      <td
                        style={{
                          padding: '12px',
                          textAlign: 'center',
                          fontWeight: 'bold',
                          color:
                            r.estado === 'Caducado'
                              ? '#b00020'
                              : r.estado === 'Próximo a expirar'
                              ? '#ff9800'
                              : '#2e7d32',
                        }}
                      >
                        {r.estado}
                      </td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>{r.unidades}</td>

                      {/* Icon buttons */}
                      {[
                        { src: 'iconoAdd.png', alt: 'Agregar', onClick: () => abrirModalAgregarUnidades(r) },
                        { src: '/iconoRest.png', alt: 'Restar', onClick: () => abrirModalRestar(r) },
                        { src: '/iconoMail.png', alt: 'Solicitar', onClick: () => abrirModalSolicitar(r) },
                        { src: '/iconoUpdate.png', alt: 'Editar', onClick: () => abrirModalEditar(r) },
                        { src: '/iconoDelete.png', alt: 'Eliminar', onClick: () => abrirModalEliminar(r) },
                      ].map(({ src, alt, onClick }) => (
                        <td key={alt} style={{ padding: '12px', textAlign: 'center' }}>
                          <img
                            src={src}
                            alt={alt}
                            title={alt}
                            style={iconButtonStyle}
                            onClick={onClick}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            onMouseDown={handleMouseDown}
                            onMouseUp={handleMouseUp}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Botón flotante + Nuevo Insumo (solo admin) */}

          <RoleView allowedRole="admin">
            <button
              onClick={() => {
                setModalNuevoInsumo(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              style={{
                position: 'fixed',
                bottom: '2rem',
                right: '2rem',
                background: '#47b9b6',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: '60px',
                height: '60px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                cursor: 'pointer',
                zIndex: 999,
                transition: 'all 0.25s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#246361';
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#47b9b6';
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = 'scale(0.95)';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = 'scale(1.1)';
              }}
              title="Agregar nuevo producto"
            >
              <FaBoxOpen size={24} />
            </button>
          </RoleView>
        {/* MODALES */}
      {modalAgregarUnidades && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}
    onClick={() => setModalAgregarUnidades(false)}
  >
    <div
      style={{
        background: '#fff',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '400px',
        maxHeight: '90vh',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Título fijo */}
      <h3 style={{ margin: '1rem 1rem 0' }}>Agregar cantidad recibida</h3>
      <p style={{ margin: '0.5rem 1rem', fontWeight: 'bold' }}>{productoSel?.nombre}</p>

      {/* Cuerpo scrolleable */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '0 1.5rem 1rem'
        }}
      >
        <label>Cantidad de entrada:</label>
        <input
          type="number"
          min="1"
          value={cantidadAdd}
          onChange={(e) => setCantidadAdd(e.target.value)}
          style={{
            width: '100%',
            padding: '0.5rem',
            fontSize: '1rem',
            borderRadius: '8px',
            border: '1px solid #ccc',
            marginBottom: '1rem'
          }}
        />
      </div>

      {/* Botones fijos con efectos */}
      <div
        style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          padding: '1rem 1.5rem',
          borderTop: '1px solid #eee'
        }}
      >
        <button
          onClick={() => setModalAgregarUnidades(false)}
          style={{
            padding: '0.6rem 1.2rem',
            border: 'none',
            borderRadius: '6px',
            background: '#615e5c',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.25s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#3d3b3a';
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#615e5c';
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.98)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
        >
          Cancelar
        </button>

        <button
          onClick={confirmarAgregar}
          style={{
            padding: '0.6rem 1.2rem',
            border: 'none',
            borderRadius: '6px',
            background: '#47b9b6',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.25s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#246361';
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#47b9b6';
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.98)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
        >
          Agregar
        </button>
      </div>
    </div>
  </div>
)}

      {/* Modal RESTAR */}

 {modalRestar && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}
    onClick={() => setModalRestar(false)}
  >
    <div
      style={{
        background: '#fff',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '400px',
        maxHeight: '90vh',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Título fijo */}
      <h3 style={{ margin: '1rem 1rem 0' }}>Registrar cantidad de salida de:</h3>
      <p style={{ margin: '0.5rem 1rem', fontWeight: 'bold' }}>{productoResta?.nombre}</p>

      {/* Cuerpo scrolleable */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '0 1.5rem 1rem'
        }}
      >
        <label>Cantidad de salida:</label>
        <input
          type="number"
          min="1"
          value={cantidadResta}
          onChange={(e) => setCantidadResta(e.target.value)}
          style={{
            width: '100%',
            padding: '0.5rem',
            fontSize: '1rem',
            borderRadius: '8px',
            border: '1px solid #ccc',
            marginBottom: '1rem'
          }}
        />

        <label style={{ display: 'block', marginTop: '1rem' }}>Sucursal destino:</label>
        <select
          value={sucursalId}
          onChange={(e) => setSucursalId(e.target.value)}
          style={{
            width: '100%',
            padding: '0.5rem',
            fontSize: '1rem',
            borderRadius: '8px',
            border: '1px solid #ccc'
          }}
        >
          <option value="">-- Selecciona sucursal --</option>
          {sucursales.map(s => (
            <option key={s.id} value={s.id}>{s.nombre}</option>
          ))}
        </select>
      </div>

      {/* Botones fijos con efectos */}
      <div
        style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          padding: '1rem 1.5rem',
          borderTop: '1px solid #eee'
        }}
      >
        <button
          onClick={() => setModalRestar(false)}
          style={{
            padding: '0.6rem 1.2rem',
            border: 'none',
            borderRadius: '6px',
            background: '#615e5c',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.25s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#3d3b3a';
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#615e5c';
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.98)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
        >
          Cancelar
        </button>

        <button
          onClick={confirmarResta}
          style={{
            padding: '0.6rem 1.2rem',
            border: 'none',
            borderRadius: '6px',
            background: '#47b9b6',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.25s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#246361';
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#47b9b6';
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.98)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
        >
          Descontar
        </button>
      </div>
    </div>
  </div>
)}

{/* MODAL SOLICITAR – solo SALIDAS, destinatario fijo */}
{modalSolicitar && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}
    onClick={() => setModalSolicitar(false)}
  >
    <div
      style={{
        background: '#fff',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '420px',
        maxHeight: '90vh',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Título fijo */}
      <h3 style={{ margin: '1rem 1rem 0' }}>Enviar solicitud por correo</h3>

      {/* Cuerpo scrolleable */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '0 1.5rem 1rem'
        }}
      >
        <p style={{ marginBottom: '1.5rem', color: '#555' }}>
          <strong>{productoSolicita?.nombre}</strong>
        </p>

        {/* Aviso fijo – no editable */}
        <p style={{ marginBottom: '1.5rem', fontSize: '0.9rem', color: '#666' }}>
          Verifica que el producto realmente necesita ser repuesto.
        </p>
      </div>

      {/* Botones fijos con efectos */}
      <div
        style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          padding: '1rem 1.5rem',
          borderTop: '1px solid #eee'
        }}
      >
        <button
          onClick={() => setModalSolicitar(false)}
          style={{
            padding: '0.6rem 1.2rem',
            border: 'none',
            borderRadius: '6px',
            background: '#615e5c',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.25s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#3d3b3a';
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#615e5c';
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.98)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
        >
          Cancelar
        </button>

        <button
          onClick={confirmarSolicitud}
          style={{
            padding: '0.6rem 1.2rem',
            border: 'none',
            borderRadius: '6px',
            background: '#47b9b6',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.25s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#246361';
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#47b9b6';
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.98)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
        >
          Confirmar envío
        </button>
      </div>
    </div>
  </div>
)}
 {/* MODAL para EDITAR INSUMO */}
{modalEditarInsumo && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}
    onClick={() => setModalEditarInsumo(false)}
  >
    <div
      style={{
        background: '#fff',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '420px',
        maxHeight: '90vh',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Título fijo */}
      <h3 style={{ margin: '1rem 1rem 0' }}>Editar insumo</h3>
      <p style={{ fontWeight: 'bold', margin: '0.5rem 1rem', color: '#333' }}>
        {insumoSeleccionado?.nombre}
      </p>

      {/* Cuerpo scrolleable */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '0 1.5rem 1rem'
        }}
      >
        <label>Marca:</label>
        <input
          type="text"
          placeholder="Ej. Sigma-Aldrich"
          value={editarMarca}
          onChange={(e) => setEditarMarca(e.target.value)}
          style={inputStyle}
        />

        <label>Presentación:</label>
        <input
          type="text"
          placeholder="Ej. 500 mL"
          value={editarPresentacion}
          onChange={(e) => setEditarPresentacion(e.target.value)}
          style={inputStyle}
        />

        {/* Checkbox para vencimiento */}
        <div style={{ marginBottom: '1rem', textAlign: 'left' }}>
          <input
            type="checkbox"
            id="requiereVencimiento"
            checked={requiereVencimiento}
            onChange={(e) => setRequiereVencimiento(e.target.checked)}
          />
          <label htmlFor="requiereVencimiento" style={{ marginLeft: '0.5rem' }}>
            Este producto requiere control de vencimiento
          </label>
        </div>

        {/* Campo de fecha condicionado */}
        <label>Fecha de vencimiento:</label>
        <input
          type="date"
          value={editarFecha}
          onChange={(e) => setEditarFecha(e.target.value)}
          disabled={!requiereVencimiento}
          style={{
            width: '100%',
            padding: '0.6rem',
            fontSize: '1rem',
            borderRadius: '8px',
            border: '1px solid #ccc',
            marginBottom: '1rem',
            backgroundColor: !requiereVencimiento ? '#eee' : 'white'
          }}
        />

        <label>Lote:</label>
        <input
          type="text"
          placeholder="Ej. L12345"
          value={editarLote}
          onChange={(e) => setEditarLote(e.target.value)}
          style={inputStyle}
        />
      </div>

      {/* Botones fijos con efectos */}
      <div
        style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          padding: '1rem 1.5rem',
          borderTop: '1px solid #eee'
        }}
      >
        <button
          onClick={() => setModalEditarInsumo(false)}
          style={{
            padding: '0.6rem 1.2rem',
            border: 'none',
            borderRadius: '6px',
            background: '#615e5c',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.25s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#3d3b3a';
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#615e5c';
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.98)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
        >
          Cancelar
        </button>
        <button
          onClick={confirmarEdicion}
          style={{
            padding: '0.6rem 1.2rem',
            border: 'none',
            borderRadius: '6px',
            background: '#47b9b6',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.25s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#246361';
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#47b9b6';
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.98)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
        >
          Guardar
        </button>
      </div>
    </div>
  </div>
)}

         {/* MODAL para ELIMINAR INSUMO */}
{modalEliminarInsumo && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}
    onClick={() => setModalEliminarInsumo(false)}
  >
    <div
      style={{
        background: '#fff',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '420px',
        maxHeight: '90vh',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Título fijo */}
      <h3 style={{ margin: '1rem 1rem 0' }}>¿Eliminar insumo?</h3>

      {/* Cuerpo scrolleable */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '0 1.5rem 1rem'
        }}
      >
        <p style={{ marginBottom: '1.5rem' }}>
          Esta acción no se puede deshacer. ¿Deseas eliminar <strong>{insumoAEliminar?.nombre}</strong>?
        </p>
      </div>

      {/* Botones fijos con efectos */}
      <div
        style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          padding: '1rem 1.5rem',
          borderTop: '1px solid #eee'
        }}
      >
        {/* Cancelar */}
        <button
          onClick={() => setModalEliminarInsumo(false)}
          style={{
            padding: '0.6rem 1.2rem',
            border: 'none',
            borderRadius: '6px',
            background: '#615e5c',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.25s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#3d3b3a';
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#615e5c';
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.98)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
        >
          Cancelar
        </button>

        {/* Eliminar */}
        <button
          onClick={confirmarEliminacion}
          style={{
            padding: '0.6rem 1.2rem',
            border: 'none',
            borderRadius: '6px',
            background: '#e74c3c',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.25s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#c0392b';
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#e74c3c';
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.98)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
        >
          Eliminar
        </button>
      </div>
    </div>
  </div>
)}
{/* MODAL para AÑADIR INSUMO NUEVO */}
<RoleView allowedRole="admin">
  {modalNuevoInsumo && (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
      onClick={() => setModalNuevoInsumo(false)}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '12px',
          width: '90%',
          maxWidth: '420px',
          maxHeight: '90vh',
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Título fijo */}
        <h3 style={{ margin: '1rem 1rem 0' }}>Agregar nuevo insumo</h3>

        {/* Cuerpo scrolleable */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: '0 1.5rem 1rem'
          }}
        >
          <label>Nombre:</label>
          <input
            type="text"
            placeholder="Ej. Metanol"
            value={nuevoNombre}
            onChange={(e) => setNuevoNombre(e.target.value)}
            style={{
              width: '100%',
              padding: '0.6rem',
              fontSize: '1rem',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: '1rem'
            }}
          />

          <label>Marca:</label>
          <input
            type="text"
            placeholder="Ej. Sigma-Aldrich"
            value={nuevoMarca}
            onChange={(e) => setNuevoMarca(e.target.value)}
            style={{
              width: '100%',
              padding: '0.6rem',
              fontSize: '1rem',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: '1rem'
            }}
          />

          <label>Presentación:</label>
          <input
            type="text"
            placeholder="Ej. 500 mL"
            value={nuevoPresentacion}
            onChange={(e) => setNuevoPresentacion(e.target.value)}
            style={{
              width: '100%',
              padding: '0.6rem',
              fontSize: '1rem',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: '1rem'
            }}
          />

          <div style={{ marginBottom: '1rem', textAlign: 'left' }}>
            <input
              type="checkbox"
              id="requiereVencimiento"
              checked={requiereVencimiento}
              onChange={(e) => setRequiereVencimiento(e.target.checked)}
            />
            <label htmlFor="requiereVencimiento" style={{ marginLeft: '0.5rem' }}>
              Este producto requiere control de vencimiento
            </label>
          </div>

          <label>Fecha de vencimiento:</label>
          <input
            type="date"
            value={nuevoFecha}
            onChange={(e) => setNuevoFecha(e.target.value)}
            disabled={!requiereVencimiento}
            style={{
              width: '100%',
              padding: '0.6rem',
              fontSize: '1rem',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: '1rem',
              backgroundColor: !requiereVencimiento ? '#eee' : 'white'
            }}
          />

          <label>Unidades a agregar:</label>
          <input
            type="number"
            min="1"
            value={nuevoUnidades}
            onChange={(e) => setNuevoUnidades(e.target.value)}
            style={{
              width: '100%',
              padding: '0.6rem',
              fontSize: '1rem',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: '1.5rem'
            }}
          />

          <label>Lote:</label>
          <input
            type="text"
            placeholder="Ej. L12345"
            value={nuevoLote}
            onChange={(e) => setNuevoLote(e.target.value)}
            style={{
              width: '100%',
              padding: '0.6rem',
              fontSize: '1rem',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: '1.5rem'
            }}
          />
        </div>

        {/* Botones fijos con efectos */}
        <div
          style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            padding: '1rem 1.5rem',
            borderTop: '1px solid #eee'
          }}
        >
          <button
            onClick={() => setModalNuevoInsumo(false)}
            style={{
              padding: '0.6rem 1.2rem',
              border: 'none',
              borderRadius: '6px',
              background: '#615e5c',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '0.9rem',
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 'bold',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              transition: 'all 0.25s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#3d3b3a';
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#615e5c';
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.transform = 'scale(0.98)';
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
          >
            Cancelar
          </button>
          <button
            onClick={confirmarNuevo}
            style={{
              padding: '0.6rem 1.2rem',
              border: 'none',
              borderRadius: '6px',
              background: '#47b9b6',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '0.9rem',
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 'bold',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              transition: 'all 0.25s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#246361';
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#47b9b6';
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.transform = 'scale(0.98)';
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  )}
</RoleView>
      </main>
    </div>
  );
};

export default Insumos;